import { IRule, IRuleEngines } from './entities';
import { getRulesEngine } from './getRulesEngine';

export function setRuleEngines(rules: IRule[]) {
	const ruleEngines: IRuleEngines = {};
	rules.forEach(r => {
		if (ruleEngines[r.id]) {
			if (r.statement.typeName === 'IfStatement') {
				if (ruleEngines[r.id].if) {
					ruleEngines[r.id].if.addRule({
						conditions: r.conditions,
						event: r.event
					});
				} else {
					ruleEngines[r.id].if = getRulesEngine().addRule({
						conditions: r.conditions,
						event: r.event
					});
				}
			} else if (r.statement.typeName === 'ElseIfStatement') {
				if (ruleEngines[r.id].elseif) {
					if (ruleEngines[r.id].elseif[r.statement.id]) {
						ruleEngines[r.id].elseif[r.statement.id].addRule({
							conditions: r.conditions,
							event: r.event
						});
					} else {
						ruleEngines[r.id].elseif[r.statement.id] = getRulesEngine().addRule({
							conditions: r.conditions,
							event: r.event
						});
					}
				} else {
					ruleEngines[r.id].elseif = {
						[r.statement.id]: getRulesEngine().addRule({
							conditions: r.conditions,
							event: r.event
						})
					};
				}
			} else {
				if (ruleEngines[r.id].else) {
					ruleEngines[r.id].else.addRule({
						conditions: r.conditions,
						event: r.event
					});
				} else {
					ruleEngines[r.id].else = getRulesEngine().addRule({
						conditions: r.conditions,
						event: r.event
					});
				}
			}
		} else {
			if (r.statement.typeName === 'IfStatement') {
				ruleEngines[r.id] = {
					...ruleEngines[r.id],
					if: getRulesEngine().addRule({
						conditions: r.conditions,
						event: r.event
					})
				};
			} else if (r.statement.typeName === 'ElseIfStatement') {
				ruleEngines[r.id] = {
					...ruleEngines[r.id],
					elseif: {
						[r.statement.id]: getRulesEngine().addRule({
							conditions: r.conditions,
							event: r.event
						})
					}
				};
			} else {
				ruleEngines[r.id] = {
					...ruleEngines[r.id],
					else: getRulesEngine().addRule({
						conditions: r.conditions,
						event: r.event
					})
				};
			}
		}
	});
	return ruleEngines;
}
